import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'home',

    data() {
        return {
            username: '',
            password: '',
        }
    },

    computed: {
        ...mapGetters({
            user: 'user/user',
        }),
    },

    methods: {
        ...mapActions('user', ['login']),
    },

    watch: {
        'user.loginError': function (value) {
            if (value === 'USER_LOGIN_FAILURE_INVALID_CREDENTIALS') {
                this.$toast.error('Korisničko ime ili šifra koje ste uneli nisu tačni. Molimo proverite podatke i pokušajte ponovo.');
            }
        }
    },
}